/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RotatableOAuthAppTypeEnum = 'ASUP' | 'DRC' | 'VCF' | 'VMC' | 'VMC_POOL';

export const RotatableOAuthAppTypeEnum = {

    ASUP: 'ASUP' as RotatableOAuthAppTypeEnum,

    DRC: 'DRC' as RotatableOAuthAppTypeEnum,

    VCF: 'VCF' as RotatableOAuthAppTypeEnum,

    VMC: 'VMC' as RotatableOAuthAppTypeEnum,

    VMC_POOL: 'VMC_POOL' as RotatableOAuthAppTypeEnum
};

